module.exports = __webpack_public_path__ + "static/media/Logo.svg.1602fd18.png";